/**
 * UI Constants for the Authentication Module
 *
 * Centralized UI timing and interaction values for consistent behavior
 */

/** Timing constants for UI interactions (in milliseconds) */
export const UI_TIMING = {
  /** Standard redirect delay for successful logout */
  LOGOUT_SUCCESS_REDIRECT_DELAY: 1500,

  /** Extended redirect delay for error scenarios to show error message */
  LOGOUT_ERROR_REDIRECT_DELAY: 2000,

  /** Debug info refresh interval for development mode */
  DEBUG_INFO_REFRESH_INTERVAL: 2000
} as const;

/** Authentication flow step timing */
export const FLOW_TIMING = {
  /** Default delay before redirecting after authentication success */
  POST_AUTH_REDIRECT_DELAY: 1500,

  /** Delay before redirecting after showing error messages */
  ERROR_MESSAGE_DISPLAY_DELAY: 2000,

  /**
   * How long the access-redirect interstitial counts down before automatically
   * sending the user to an accessible module. The user can also skip the wait
   * with the manual continue button.
   */
  ACCESS_REDIRECT_COUNTDOWN_MS: 5000,

  /**
   * Delay before performing the post-IDP redirect so React state (session id,
   * system id, API configuration) finishes synchronizing before we navigate
   * away. Only applied on the IDP callback path via `handleSecureRedirect`'s
   * `addDelay` option.
   */
  IDP_REDIRECT_SYNC_DELAY_MS: 250
} as const;
